import { withErrorBoundary } from "app/ErrorBoundary/ErrorBoundaryDashboard";
import {
  SharedContentGridLayout,
  SharedGridStyle,
} from "features/CenterContent/shared/MainContentGrid";
import TabsCenter from "features/CenterContent/shared/Tabs/TabsCenter";
import { AlternativeTransportLeftPanel } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/AlternativeTransportLeftPanel";
import { AlternativeTransportRightPanel } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/AlternativeTransportRightPanel";
import { useAlternativeTransportData } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/utils";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";
import { NoDataMessage } from "shared/components/feedback/NoDataMessage/NoDataMessage";
import SkeletonLoader from "shared/components/feedback/SkeletonLoader/SkeletonLoader";
import { AlternativeTransportVehicle } from "shared/types/alternativeTransport";
import styled from "styled-components";

import { MOCK_ALTERNATIVE_TRANSPORT_VEHICLE } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/MOCK_alternativeTransport";

const USE_MOCK_DATA = true;

const ErrorContainer = styled.div`
  ${SharedContentGridLayout};
  ${SharedGridStyle};
  box-sizing: border-box;
`;

const PanelRow = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 872px;
  display: flex;
  flex-direction: row;
  container-type: inline-size;
  container-name: altTransportPage;
`;

const PanelColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

const DetailsLoader = () => (
  <div style={{ width: "100%" }}>
    <SkeletonLoader skeletonType="trainStops" />
  </div>
);

const AlternativeTransportDetails = () => {
  const { vehicleUuid } = useParams();

  const [vehicle, setVehicle] = useState<AlternativeTransportVehicle | null>(
    null,
  );

  const { status, data } = useAlternativeTransportData(vehicleUuid);

  useEffect(() => {
    if (data) {
      setVehicle(data.alternativeTransportResponseVehicle);
    }
  }, [data, status]);

  const getContent = () => {
    if (USE_MOCK_DATA) {
      const mockVehicle = MOCK_ALTERNATIVE_TRANSPORT_VEHICLE;
      return (
        <PanelRow>
          <PanelColumn>
            <AlternativeTransportLeftPanel vehicle={mockVehicle} />
          </PanelColumn>
          <PanelColumn>
            <AlternativeTransportRightPanel vehicle={mockVehicle} />
          </PanelColumn>
        </PanelRow>
      );
    }

    switch (status) {
      case "pending":
        return <DetailsLoader />;
      case "success": {
        return vehicle ? (
          <PanelRow>
            <PanelColumn>
              <AlternativeTransportLeftPanel vehicle={vehicle} />
            </PanelColumn>
            <PanelColumn>
              <AlternativeTransportRightPanel vehicle={vehicle} />
            </PanelColumn>
          </PanelRow>
        ) : (
          <ErrorContainer>
            <NoDataMessage reason="Fant ingen detaljer om bussen" />
          </ErrorContainer>
        );
      }
      case "error":
        return (
          <ErrorContainer>
            <FailureMessage />
          </ErrorContainer>
        );
    }
  };

  return (
    <>
      <TabsCenter />
      {getContent()}
    </>
  );
};

export default withErrorBoundary(AlternativeTransportDetails);
